import PropTypes from 'prop-types';

export const GA_SCROLL_COLLECTIONS_ACTION = 'ScrollCollections';
export const GA_CLICK_VIEW_COLLECTION_ACTION = 'ViewEditorialCollection';

export const COLLECTIONS_PROPTYPES = PropTypes.arrayOf(
    PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
        summary: PropTypes.string,
        creator: PropTypes.shape({
            image: PropTypes.shape({
                url: PropTypes.string,
            }),
        }),
        imageLarge: PropTypes.shape({
            url: PropTypes.string,
        }),
        eventCount: PropTypes.number,
        creatorImageIdOverrideUrl: PropTypes.string,
    }),
);
